import { ApplicationSource, NpsReviewsTemplateConfig } from '@smooved/ui';

export const reviewsTemplateConfig: NpsReviewsTemplateConfig = {
    application: ApplicationSource.SmoovedApp,
    includeTopicsAnalysis: true,
    removePadding: true,
    showReviewVia: true,
};
